import { render, staticRenderFns } from "./MapTest.vue?vue&type=template&id=2445e326&"
import script from "./MapTest.vue?vue&type=script&lang=js&"
export * from "./MapTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports